import React, { useMemo } from 'react';
import { Skeleton, Tooltip } from '@mui/material';
import clsx from 'clsx';
import { StyledGrid, StyledTypography } from 'components/AllocationStatusBadge/styles';
import { APPROVED_FOR_CLIENTS_TOOLTIP, DISABLED_TOOLTIP, DRAFT_TOOLTIP } from 'dashboard409a/common/constants';
import { BadgeStatus, ReportStatusBadgeProps } from './ReportStatusBadge.props';

const ReportStatusBadge = ({
  isApproved,
  loading,
  isCompanyUserAndIsNotApprovedForClients = false,
  isSuperuserOrStaff = false,
}: ReportStatusBadgeProps) => {
  const { status, label, tooltip } = useMemo(() => {
    if (isCompanyUserAndIsNotApprovedForClients) {
      return {
        status: 'under-review' as BadgeStatus,
        label: 'Under Review',
        tooltip: DISABLED_TOOLTIP,
      };
    }

    if (isApproved && isSuperuserOrStaff) {
      return {
        status: 'ready-for-audit' as BadgeStatus,
        label: 'Approved for Clients',
        tooltip: APPROVED_FOR_CLIENTS_TOOLTIP,
      };
    }

    if (!isApproved && isSuperuserOrStaff) {
      return {
        status: 'draft' as BadgeStatus,
        label: 'Draft',
        tooltip: DRAFT_TOOLTIP,
      };
    }

    return {
      status: 'none' as BadgeStatus,
      label: '',
      tooltip: '',
    };
  }, [isApproved, isCompanyUserAndIsNotApprovedForClients, isSuperuserOrStaff]);

  if (loading) {
    return <Skeleton variant="rect" width={100} height={30} />;
  }

  return (
    <Tooltip title={tooltip} style={{ cursor: 'default' }}>
      <StyledGrid
        className={clsx({
          [status]: true,
        })}
        data-testid="approved-for-clients-or-draft-badge">
        <StyledTypography
          className={clsx({
            [status]: true,
          })}
          paragraph>
          {label}
        </StyledTypography>
      </StyledGrid>
    </Tooltip>
  );
};

export default ReportStatusBadge;
